<template>
  <!-- model-value is always null: this acts as a one-shot trigger, not a bound select.
       After emitting 'switch', the parent navigates away so no selected state is needed. -->
  <RevInputSelectSearchable
    :id
    hide-checkboxes
    :label="cleanLabel"
    :model-value="null"
    :no-options-message="i18n(translations.noProductFound)"
    :options="cleanOptions"
    search-placement="dropdown"
    @update:model-value="onSelect"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import {
  type Option,
  RevInputSelectSearchable,
} from '@ds/components/InputSelectSearchable'

import translations from './ProductSwitcher.translations'

const props = defineProps<{
  id: string
  label: string
  options: { id: string; label: string; value: string }[]
}>()

const emit = defineEmits<{
  switch: [option: { value: string }]
}>()

const i18n = useI18n()

// Strip the variant suffix that comes after "•" (e.g. "iPhone 11 Pro Max • Unlocked"
// → "iPhone 11 Pro Max") so long product names stay compact in the dropdown.
function stripVariantSuffix(name: string) {
  return name.split('•')[0]?.trim() ?? name
}

const cleanLabel = computed(() => stripVariantSuffix(props.label))
const cleanOptions = computed(() =>
  props.options.map((opt) => ({
    ...opt,
    label: stripVariantSuffix(opt.label),
  })),
)

function onSelect(opt: Option | null) {
  if (opt && 'value' in opt) {
    emit('switch', { value: String(opt.value) })
  }
}
</script>
